import axios, { AxiosError } from 'axios';
import applyCaseMiddleware from 'axios-case-converter';

import { getTokenRedirect } from './msal';

// used to temporary bypass MSAL 2.0
export const djSessionId = null;
// export const djSessionId = 's1xslht0h0vzluoak8v3nzpriq7u2w2p';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

export const restapi = applyCaseMiddleware(axios.create({
	baseURL: import.meta.env.VITE_REST_API_BASE_URL,  // must include '/api/v1/'
}));

restapi.interceptors.response.use(response => {
	return response;
}, (error) => {
	if (error.response && error.response.status === 403) {
		// do not call signIn to avoid loops
		// signIn();
		console.warn('403 Restapi connection forbidden', error);
	}
	return Promise.reject(error);
});

if (!djSessionId && (import.meta.env.NODE_ENV !== "test")) {  // prevent this from being used in tests
	restapi.interceptors.request.use(async config => {
		// @ts-ignore
		const c = {headers: {}, ...config};
		const tokenResponse = await getTokenRedirect();
		if (tokenResponse) {
			c.headers['Authorization'] = `Bearer ${tokenResponse.idToken}`;
		}
		return c;
	});
}

if (djSessionId) {  // set cookie
	document.cookie = `sessionid=${djSessionId}; path=/;`;
} else {  // clear cookie
	document.cookie = "sessionid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

function extractStringValues(json: any): string[] {
	let res: string[] = [];
	for (const k in json) {
		if (typeof json[k] === 'string') {
			res.push(json[k]);
		} else if (typeof json[k] === 'object') {
			res = res.concat(extractStringValues(json[k]));
		}
	}
	return res;
}

export function extractErrorMessages(error: AxiosError) {
	const r = error.response;
	if (!r) {
		return ['Connection error, saving failed. Please retry later.'];
	} else {
		const data = r.data || {};
		if (r.status === 400) {
			return extractStringValues(data);
		} else {
			return [`Server error ${r.status}. Message: ${error.message}.`];
		}
	}
}